export interface QueryStatusProps {
  /**
   * Where the block renders: "card" (default) for the usual case, nested
   * inside a white `Card`/`CardBody`; "canvas" when it's a page's entire
   * return value (a pending/error early-return) sitting directly on the
   * page background, with no card behind it. Both read the same on this
   * app's light canvas - kept as separate values so a future surface that
   * genuinely needs to look different from a card still has a place to.
   */
  surface?: "card" | "canvas";
}

export function LoadingBlock({ label = "Loading" }: { label?: string } & QueryStatusProps) {
  return (
    <div className="flex items-center justify-center rounded-lg border border-dashed border-slate-300 py-16 text-sm text-slate-400">
      {label}&hellip;
    </div>
  );
}

export function ErrorBlock({ message }: { message: string } & QueryStatusProps) {
  return (
    <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{message}</div>
  );
}
